<template>
  <div style="height:100%;display:flex;flex-direction: column;">
    <div
      style="flex-grow:1;overflow: auto;padding-top:30px"
      ref="commentsListDisplay"
      @scroll="onScroll"
    >
      <HiCommentBubble
        v-for="comment in comments"
        :key="comment.id"
        :id="comment.id"
        :right="comment.user === currentUser.uid"
        :editable="comment.user === currentUser.uid"
        :color="comment.user === currentUser.uid ? '#eae8e4' : 'white'"
      />
      <p
        v-if="comments && comments.length"
        style="opacity:.3;text-align: center;font-size:10px;padding:20px"
      >
        ------ The End ------
      </p>
      <div
        class="full-size flex-block-center"
        v-if="!comments || comments.length === 0"
      >
        <div class="text-center" style="opacity:.4">
          <div class="pa-5"><v-icon size="50">mdi-web-clock</v-icon></div>
          No Post Yet...
        </div>
      </div>
    </div>
    <HiTextArea
      class="comment-input pa-2"
      @send="sendComment"
      ref="textarea"
      @focus="inputFocus"
    ></HiTextArea>
    <!--    independent elements-->
    <!--    <HiToast v-model="toast"></HiToast>-->
  </div>
</template>

<script>
// import axios from "axios";
import { collections } from "@/db";
import HiTextArea from "../components/HiTextArea";
// import HiAvatar from "../components/HiAvatar";
// import HiIcon from "../components/HiIcon";
import HiCommentBubble from "./CommentBubble";
import { api } from "@/api";
import hive from "@/hive";
// import HiToast from "@/components/HiToast";

export default {
  name: "Comments",
  components: {
    // HiToast,
    // HiAvatar
    //   HiIcon,
    HiCommentBubble,
    HiTextArea
  },
  props: {
    id: {
      type: String
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      comments: null,
      // toast: {},
      autoScroll: true
    };
  },
  methods: {
    async sendComment(data) {
      const obj = {
        message: data,
        targetId: this.id
      };
      // console.log(data);
      const result = await api.leads.commentHandler(obj);
      if (result.error) {
        hive.toastError("Server Error: " + result.error);
        this.$refs.textarea.restart(true);
        console.log(result.error);
      } else {
        // hive.toastSuccess("Submitted!");
        this.$refs.textarea.restart();
      }
    },
    scrollToBottom() {
      const display = this.$refs.commentsListDisplay;
      display.scrollTo({
        top: display.scrollHeight,
        left: 0,
        behavior: "smooth"
      });
    },
    onScroll() {
      const display = this.$refs.commentsListDisplay;
      this.autoScroll =
        display.scrollTop + display.clientHeight >= display.scrollHeight - 60;
      // console.log(this.autoScroll);
      // console.log(
      //   display.scrollTop +
      //     " " +
      //     display.scrollHeight +
      //     " " +
      //     display.clientHeight
      // );
    },
    async inputFocus() {
      console.log("focus");
      //warm up the comments callable
      // console.log(data);
      try {
        await api.leads.commentHandler({});
      } catch (e) {
        e;
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters["user/getUser"];
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(id) {
        if (id == null) return;
        // console.log(this.type + "/" + id);
        this.$bind(
          "comments",
          collections.comments
            .where("location", "==", this.type + "/" + id)
            .orderBy("dateCreated")
        );
      }
    },
    comments: {
      // immediate: true,
      handler: function() {
        if (!this.autoScroll) return;
        setTimeout(() => this.scrollToBottom(), 100);
        setTimeout(() => this.scrollToBottom(), 1000); //to make sure scroll to bottom when data load delays.
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.comment-input {
  background-color: $light4;
  box-shadow: inset 0px 1px 3px #999999;
  padding: 2px;
}
</style>
